export default __webpack_public_path__ + "static/media/survey-light-theme.5ae49e75.png";